import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { storeService } from '@kss/api';
import type { StoreCreate } from '@kss/api';
import { loadCompanyOptions } from '../shared/formLoaders';

const columns: BulkColumn<StoreCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Main Store' },
  { key: 'code', header: 'Code', sample: 'STR-001' },
  { key: 'address', header: 'Address' },
  { key: 'companyId', header: 'Company', dataType: 'lookup', loadOptions: loadCompanyOptions },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkStore() {
  return (
    <BulkSpreadsheet<StoreCreate> title="Bulk import stores" entityLabel="store" backPath="/panel/stores" columns={columns} module="Store"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await storeService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
